import React from "react";

import { faExternalLinkAlt } from "@fortawesome/pro-solid-svg-icons/faExternalLinkAlt";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Col from "antd/es/col";
import Row from "antd/es/row";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { EntityType, EntityTypeSupportingDataMerging } from "@mapmycustomers/shared/types/entity";
import { DuplicableEntity } from "@mapmycustomers/shared/types/entity/Duplicate";

import Path from "@app/enum/Path";
import layout from "@app/styles/layout";
import { formatRawDate } from "@app/util/formatters";

import styles from "./EntityCell.module.scss";

interface Props {
  entity: DuplicableEntity;
  entityType: EntityTypeSupportingDataMerging;
}

const EntityCell: React.FC<Props> = ({ entity, entityType }) => {
  const intl = useIntl();

  return (
    <div>
      <Row align="middle" gutter={layout.spacerS}>
        <Col>{entity.name}</Col>
        <Col>
          <Link
            rel="noopener noreferrer"
            target="_blank"
            to={`${entityType === EntityType.COMPANY ? Path.COMPANY : Path.PEOPLE}/${entity.id}`}
          >
            <FontAwesomeIcon className={styles.icon} icon={faExternalLinkAlt} />
          </Link>
        </Col>
      </Row>
      <div className={styles.date}>
        {intl.formatMessage(
          {
            id: "settings.mergeDuplicates.previewMergePane.header.entityColumn.created",
            defaultMessage: "Created on {date}",
            description:
              "Settings Merge duplicates - preview/merge pane - fields table - entity column - created",
          },
          { date: formatRawDate(entity.createdAt, "PPP") }
        )}
      </div>
      <div className={styles.date}>
        {intl.formatMessage(
          {
            id: "settings.mergeDuplicates.previewMergePane.header.entityColumn.updated",
            defaultMessage: "Last updated on {date}",
            description:
              "Settings Merge duplicates - preview/merge pane - fields table - entity column - updated",
          },
          { date: formatRawDate(entity.updatedAt, "PPP") }
        )}
      </div>
    </div>
  );
};

export default EntityCell;
